import api from './api';

// Historial de Cierres Z que lleva el sistema (la impresora tiene el suyo, pero no
// podemos consultarlo sin que esté prendida). Sirve para saber si el de hoy ya se hizo.

export interface ZClosure {
  id: number;
  business_date: string;          // YYYY-MM-DD (día argentino)
  numero?: string | null;         // N° de Z que devolvió la impresora
  closed_at?: string | null;
  closed_by_name?: string | null;
  fiscal_sales_count: number;     // ventas fiscales de ese día según el sistema
  fiscal_sales_total: number;
}

export interface ZStatus {
  today: string;
  done_today: boolean;
  today_closure?: ZClosure | null;
  pending_sales_count: number;
  pending_sales_total: number;
  unclosed_previous_date?: string | null;  // día anterior que quedó sin cerrar
  tracking_since?: string | null;          // desde cuándo el sistema lleva registro
  history: ZClosure[];
}

export interface FiscalOperation {
  id: number;
  operacion: string;              // imprimir | nota-credito | reimprimir | cierre-z
  ok: boolean;
  sale_id?: number | null;
  numero_comprobante?: string | null;
  identificador?: string | null;  // CMD_INVALID_STATE, PROXY_NO_DISPONIBLE...
  comando?: string | null;
  mensaje?: string | null;
  trace?: string | null;          // secuencia de comandos con sus tiempos
  duracion_ms?: number | null;
  created_at?: string | null;
  created_by_name?: string | null;
}

export const fiscalZService = {
  async getStatus(): Promise<ZStatus> {
    const { data } = await api.get<ZStatus>('/fiscal/cierre-z');
    return data;
  },

  // Se llama DESPUÉS de que la impresora hizo el cierre, para dejar constancia.
  // businessDate (YYYY-MM-DD) solo para cargar uno viejo hecho desde la impresora;
  // sin fecha se asume hoy.
  // Bitácora de la impresora: todo lo que se le pidió, salga bien o mal
  async getOperaciones(soloErrores = false, limit = 50): Promise<FiscalOperation[]> {
    const { data } = await api.get<FiscalOperation[]>('/fiscal/operaciones', {
      params: { solo_errores: soloErrores, limit },
    });
    return data;
  },

  async register(numero?: string | null, businessDate?: string, notes?: string): Promise<ZClosure> {
    const { data } = await api.post<ZClosure>('/fiscal/cierre-z', {
      numero: numero ?? null,
      business_date: businessDate ?? null,
      notes,
    });
    return data;
  },
};
